<template>
  <section class="proposal-page__section recipient">
    <div class="pp-container --is-narrow">
      <div class="recipient__sheet">
        <p v-html="data.message"></p>

        <p class="recipient__issued" v-if="data.date_issued !== '' && data.date_valid !== ''"><small>Erstellt am: {{ data.date_issued }} — Gültig bis: {{ data.date_valid }}</small></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Recipient',
  props: ['data']
};
</script>

<style lang="scss" scoped>
/**
 * Recipient
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Recipient information and message
 * @since 2020-11-11
**/

$component: 'recipient';

.#{$component} {
  &__sheet {
    position: relative;
    padding-top: 120px;
    @include padding-bottom(map-get($spacers, 6));
    @include padding-left(map-get($spacers, 4) * 3);
    @include padding-right(map-get($spacers, 4) * 3);
    border: 1px solid rgba(0, 0, 0, 0.02);
    border-radius: 2px;
    box-shadow: 0px 17px 19px rgba(0, 0, 0, 0.07);
    background: linear-gradient(147deg, #F6F6F6 21.79%, #FFFFFF 75.76%);
    @include font-size(map-get($proposal-page, 'font-size-lg'));
    font-family: 'Frank Ruhl Libre';
    font-weight: 300;
    text-shadow: 1px 1px 1px $white;
    z-index: 0;

    &:before {
      content: '';
      position: absolute;
      top: -14px;
      left: 0;
      width: 200px;
      height: 100%;
      background: url('~@/assets/images/paper-clip.png') top left no-repeat;
      background-size: contain;
      pointer-events: none;
      z-index: -1;
    }
  }
  &__breakdown {
    @include margin-top(map-get($spacers, 5));
    @include margin-bottom(map-get($spacers, 6));
  }

  &__row {
    display: flex;
    @include padding-top(map-get($spacers, 2));
    @include padding-bottom(map-get($spacers, 2));
    border-bottom: 1px solid $gray-ghost-fixed;

    div:nth-child(1) {
      width: 70%;
    }

    div:nth-child(2) {
      width: 30%;
      text-align: right;
      font-weight: $font-weight-bold;
    }
  }

  &__issued {
    margin: 0;
    color: $ink-lightest;
  }
}
</style>
